import type React from 'react';

import { fieldError, setClass } from '../../helpers/utils';
import './styles.scss';

type RadioProps = {
	name?: string;
	id?: string;
	value?: string | number;
	label?: React.ReactNode;
	checked?: boolean;
	className?: string;
	disabled?: boolean;
	inGroup?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	hookForm?: any;
};

export const Radio = ({
	name,
	id,
	value,
	label,
	checked,
	className = '',
	disabled,
	inGroup = false,
	onChange,
	hookForm = { formState: { errors: {} } } as any,
}: RadioProps) => {
	const {
		register,
		formState: { errors },
	} = hookForm;

	const handleChange = (event) => {
		if (typeof onChange === 'function') {
			onChange(event);
		}
	};

	return (
		<div
			className={setClass(`radio
        ${fieldError(errors, name) ? ' is-error' : ''}
        ${disabled ? ' is-disabled' : ''}
        ${className}`)}
		>
			<label>
				<input
					type="radio"
					name={name}
					id={id}
					value={value}
					defaultChecked={checked}
					disabled={disabled}
					{...register?.(name, {
						onChange: (e) => handleChange(e),
					})}
				/>
				<span>{label}</span>
				<div className="check"></div>
			</label>
			{fieldError(errors, name) && !inGroup && (
				<span className="message-error">
					{(fieldError(errors, name) as any).message}
				</span>
			)}
		</div>
	);
};
